var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners"},[_c('div',{staticClass:"partners-content main-content"},[_c('h2',{staticClass:"section-title"},[_vm._v("携手伙伴，共铸辉煌")]),_c('p',{staticClass:"section-sub-title"},[_vm._v("服务400+客户")]),_c('PartnerSection')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }